import React, { useContext, useEffect } from 'react'
import "./headband.scss"
import headbandContext from 'contexts/headband'
export default function HeadbandTitle(props) {
	const {headband} = useContext(headbandContext)
	const {icon, title, color} = headband
	useEffect(() => {
		console.log(title)
		document.title = title !== null ? title.replace("<br/>", " ") : "accueil"
  }, [headband])
	return (
		<div className='headband headbandTitle flex between' style={{top : title === "Capsules ANFH" ? "345px" : "0" }}>
			<div className={`headbandIcon ${ color } flex center`}>
				<img src={ "/" +icon} alt={icon} />
			</div>
			<div className="title flex center h100" style={{background : color === "bckDarkBlue" ? "#56b5e6" : "#215fa5" }}>
				<h1>
					{title}
				</h1>
			</div>
		</div>
	)
}
